module.exports = __webpack_public_path__ + "img/2_212.4f11ac90.png";